module.exports = "/static-assets/_next/static/images/paralaxBG-a0f86c62ccbd4ad74423dad07b967f08.png";